var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgJira = function SvgJira(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41431_6759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3324 -0.00134277H7.62695C7.62695 0.921176 7.99342 1.80591 8.64574 2.45823C9.29806 3.11055 10.1828 3.47702 11.1053 3.47702H12.5247V4.84751C12.526 6.7668 14.0816 8.32242 16.0009 8.32367V0.667105C16.0009 0.298036 15.7017 -0.00134277 15.3324 -0.00134277Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5198 3.83801H3.81445C3.81564 5.75731 5.3712 7.31293 7.29056 7.31418H8.70999V8.68905C8.71244 10.6084 10.2691 12.1629 12.1884 12.1629V4.50659C12.1884 4.13739 11.889 3.83801 11.5198 3.83801Z",
    fill: "url(#paint0_linear_41431_6759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70447 7.67505H-0.000976562C-0.000976562 9.5961 1.5564 11.1534 3.47738 11.1534H4.90127V12.5238C4.90252 14.4414 6.45538 15.9963 8.37298 15.9999V8.34356C8.37298 7.97437 8.07367 7.67505 7.70447 7.67505Z",
    fill: "url(#paint1_linear_41431_6759)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41431_6759",
    x1: 12.0235,
    y1: 3.85142,
    x2: 8.76562,
    y2: 7.25085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41431_6759",
    x1: 8.42867,
    y1: 7.71293,
    x2: 4.66015,
    y2: 11.4207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41431_6759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJira);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jira.4db9a0987099d7bfbecfded64936482d.svg";